import { useContext, useState } from 'react';
import {
  BulkActionsContext,
  Button,
  Flex,
  Icon,
  Modal,
  ModalContext,
  PaginationProvider,
  SortProvider,
  Text,
  useScreenResolution,
} from 'dash-ui';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

import PropertyComparisonDropDown from './components/PropertyComparisonDropDown/PropertyComparisonDropDown';
import PropertyComparisonTable from './components/PropertyComparisonTable/PropertyComparisonTable';
import {
  DEFAULT_COMPARISON_TABLE_COLUMNS,
  PropertyCompareItemsEnum,
} from './PropertyComparisonModal.constants';

const PropertyComparisonModal = () => {
  const {
    devices: { isMobile },
  } = useScreenResolution();
  const { t } = useTranslation();
  const theme = useTheme();
  const { isOpenCurrent, toggleModal } = useContext(ModalContext);
  const { resetState } = useContext(BulkActionsContext);
  const isOpen = isOpenCurrent['PropertyComparisonModal'];
  const [selectedCompareOptions, setSelectedCompareOptions] = useState<
    Record<PropertyCompareItemsEnum, boolean>
  >(DEFAULT_COMPARISON_TABLE_COLUMNS);

  const closeModal = () => {
    toggleModal(false, 'PropertyComparisonModal');
    resetState();
  };

  return (
    <Modal
      maxWidth={1146}
      maxHeight="100%"
      h={['100%', 0, 0, 0]}
      w="100%"
      isOpen={isOpen}
      onRequestClose={closeModal}
    >
      <Flex flexDirection="column" alignItems="center" minHeight={400}>
        <Flex
          justifyContent="space-between"
          flexDirection={isMobile ? 'column' : 'row'}
          alignItems="center"
          w="100%"
        >
          <Flex alignItems="center">
            <Icon
              onClick={closeModal}
              color={theme.colors.b50}
              name="cancelCircle"
              size={18}
              mr={2.5}
            />
            <Text xl semibold>
              {t('pages:portfoliosPage.propertyComparison')}
            </Text>
          </Flex>
          <Flex mt={[4, 0, 0, 0]}>
            <PropertyComparisonDropDown
              selectedCompareOptions={selectedCompareOptions}
              setSelectedCompareOptions={setSelectedCompareOptions}
            />
            {/* <Button medium disabled variation="outline" icon="downloadSolid">
              {t('common:labels.download')}
            </Button> */}
          </Flex>
        </Flex>

        <SortProvider>
          <PaginationProvider>
            <PropertyComparisonTable
              selectedCompareOptions={selectedCompareOptions}
            />
          </PaginationProvider>
        </SortProvider>
      </Flex>
    </Modal>
  );
};

export default PropertyComparisonModal;
